if(document.body.classList.contains('template-blog')) {

  const articleSliderEl = document.getElementById('article-slider')

  if(articleSliderEl) {
    const sliderOptions = {
      arrows: false,
      autoWidth: true,
      pagination: false,
      // drag: 'free'
    }

    const articleSlider = new Splide( articleSliderEl, sliderOptions ).mount()

    if(window.matchMedia('(max-width: 600px)').matches) articleSlider.destroy()
  }

}